// extracted by mini-css-extract-plugin
module.exports = {"air8-warning-popover-button__tip":"warningPopoverButton_air8-warning-popover-button__tip_3sdkW"};